import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "details user-form widget-pane aux-pane" }
const _hoisted_2 = { class: "row double long" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "email-field" }, "Email", -1)
const _hoisted_4 = { class: "row double long" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "nickname-field" }, "Name", -1)
const _hoisted_6 = { class: "row double" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "gender-field" }, "Gender", -1)
const _hoisted_8 = { class: "row double" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "dob-date-field" }, "Date of birth", -1)
const _hoisted_10 = { class: "row double" }
const _hoisted_11 = { class: "location right" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-compass compass-icon" }, null, -1)
const _hoisted_13 = { class: "lat" }
const _hoisted_14 = { class: "lat" }
const _hoisted_15 = {
  key: 1,
  class: "pi pi-question question-mark"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-map left" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-label" }, "Share location", -1)
const _hoisted_18 = { class: "row submit-row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-save left" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "text-label" }, "Save", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_InputText, {
        id: "email-field",
        type: "email",
        modelValue: _ctx.identifier,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.identifier) = $event)),
        placeholder: "Your email"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_InputText, {
        id: "nickname-field",
        type: "nickName",
        modelValue: _ctx.nickName,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nickName) = $event)),
        placeholder: "Your name",
        title: "Your name"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode(_component_Dropdown, {
        modelValue: _ctx.gender,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.gender) = $event)),
        id: "gender-field",
        options: _ctx.genderOpts,
        optionValue: "key",
        optionLabel: "title",
        placeholder: "Select a gender"
      }, null, 8, ["modelValue", "options"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode(_component_InputText, {
        id: "dob-date-field",
        type: "date",
        modelValue: _ctx.dobDate,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dobDate) = $event)),
        placeholder: "Birth Date"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("label", _hoisted_11, [
        _hoisted_12,
        (_ctx.hasLocation)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.dmsLocation.lat), 1),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.dmsLocation.lng), 1)
            ], 64))
          : (_openBlock(), _createElementBlock("i", _hoisted_15))
      ]),
      _createVNode(_component_Button, { onClick: _ctx.checkLocation }, {
        default: _withCtx(() => [
          _hoisted_16,
          _hoisted_17
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_18, [
      (_ctx.showSave)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            onClick: _ctx.save
          }, {
            default: _withCtx(() => [
              _hoisted_19,
              _hoisted_20
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}